import {Component, Input} from '@angular/core';
import {ModelStatus} from "../../../../../framework/model/modelStatus";
import {CartService} from "../../../../services/CartService";
import {CartModel} from "../../../../../framework/model/core/items/cartModel";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";

@Component({
  selector: 'app-item-action-dialog',
  templateUrl: './item-action-dialog.component.html',
  styleUrls: ['./item-action-dialog.component.css']
})
export class ItemActionDialogComponent {

  @Input()
  public cartModel:CartModel;

  public models:Array<ModelStatus> = []
  public action;
  public checked_status;
  public checked_status_code;

  constructor(public cartService:CartService, public tools:ModelToolsProvider) {
  }

  ngOnInit()
  {
    this.action = this.cartService.cartData['action'];
  }

  close()
  {
    if(!this.cartModel.data['data']['comments']['value']) this.cartModel.data['data']['comments']['value'] = '';
    this.cartModel.data['data']['comments']['value'] = this.cartModel.data['data']['comments']['value'];
    this.tools.closeModal()
  }

}
